var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcImportCompanies = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "76px",
    viewBox: "0 0 72 76",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.3.-Import",
    transform: "translate(-509.000000, -319.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(35.000000, 165.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask-2-Copy-10",
    transform: "translate(350.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-company",
    transform: "translate(124.000000, 54.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72,72 L44,72 L44,22 L64,22 C68.398,22 72,25.602 72,30 L72,72 Z",
    id: "Path",
    fill: "#BEC4CA"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#979FA8",
    points: "44 72 72 72 72 76 44 76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,32 L64,32 L64,40 L56,40 L56,32 Z M56,46 L64,46 L64,54 L56,54 L56,46 Z M56,60 L64,60 L64,68 L56,68 L56,60 Z",
    id: "Shape",
    fill: "#4F5964"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#DFE2E5",
    points: "6 0 46 0 46 8 6 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,72 L0,72 L0,10 C0,7.8 1.8,6 4,6 L48,6 C50.2,6 52,7.8 52,10 L52,72 Z",
    id: "Path",
    fill: "#EFF0F2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#DFE2E5",
    points: "0 72 52 72 52 76 0 76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,56 L30,56 L30,68 L22,68 L22,56 Z M8,56 L16,56 L16,68 L8,68 L8,56 Z M36,56 L44,56 L44,68 L36,68 L36,56 Z M22,28 L30,28 L30,36 L22,36 L22,28 Z M8,28 L16,28 L16,36 L8,36 L8,28 Z M36,28 L44,28 L44,36 L36,36 L36,28 Z M22,42 L30,42 L30,50 L22,50 L22,42 Z M8,42 L16,42 L16,50 L8,50 L8,42 Z M36,42 L44,42 L44,50 L36,50 L36,42 Z M22,14 L30,14 L30,22 L22,22 L22,14 Z M8,14 L16,14 L16,22 L8,22 L8,14 Z M36,14 L44,14 L44,22 L36,22 L36,14 Z",
    id: "Shape",
    fill: "#BEC4CA"
  }))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcImportCompanies, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-import-companies.7b3c271b.svg";
export { ForwardRef as ReactComponent };